/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ParkingProlongPriceApiFrom } from '../../models/parking-prolong-price-api-from';

export interface ApiV3ServiceGetParkingProlongPriceGet$Params {

/**
 * Interface language
 */
  lang?: string;

/**
 * parking id
 */
  prkId?: number;

/**
 * extension duration in minutes
 */
  duration?: number;
}

export function apiV3ServiceGetParkingProlongPriceGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceGetParkingProlongPriceGet$Params, context?: HttpContext): Observable<StrictHttpResponse<ParkingProlongPriceApiFrom>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceGetParkingProlongPriceGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('prkId', params.prkId, {});
    rb.query('duration', params.duration, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ParkingProlongPriceApiFrom>;
    })
  );
}

apiV3ServiceGetParkingProlongPriceGet.PATH = '/api/v3/service/GetParkingProlongPrice';
